<app-switch
  class="h-100"
  (switchValueEmit)="checkedHandler($event)"
  [ngClass]="'top-6px'"
  [isEditable]="false"
  [status]="params.value"
></app-switch>
